import Vue from 'vue';

    import { formatNumber } from '@/utils/functions.js'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
export function getComparedNumber(val, digits = 2, type, isClass = false) {
  let res = formatNumber(isClass ? val : Math.abs(val), digits, type)
  if (res === '0.00' || res === '-0.00' || res === '-0.00%' || res === '0.00%') {
    return $t('f87f9e')
  }
  return res
}

export function getComparedClass(val, digits = 2, type) {
  let res = getComparedNumber(val, digits, type, true)
  if (res === $t('f87f9e') || res === '--') {
    return 'none'
  } else if (res.indexOf('-') > -1) {
    return 'down'
  } else {
    return 'up'
  }
}
